"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var scenario_state_1 = require("../../redux/scenario/scenario.state");

var generateUrlTreeItem = function generateUrlTreeItem(url) {
  return {
    url: url
  };
};

exports.convertNodeMapToTreeData = function (parsedNodeMap, topNodeId) {
  var nodeToTreeItem = function nodeToTreeItem(node, nodeId) {
    var options = node.options;
    var TreeItem = {
      nodeId: nodeId,
      name: node.header,
      node: node,
      children: options.map(function (_ref) {
        var actionType = _ref.actionType,
            actionId = _ref.actionId,
            actionUrl = _ref.actionUrl;
        if (actionType === scenario_state_1.ActionType.Url && !!actionUrl) return generateUrlTreeItem(actionUrl);
        if (actionType === scenario_state_1.ActionType.Id && !!actionId && parsedNodeMap[actionId]) return nodeToTreeItem(parsedNodeMap[actionId], actionId);
        return {};
      })
    };
    return TreeItem;
  };

  var topNode = parsedNodeMap[topNodeId];
  if (!topNode) throw new Error("Node with given topNodeId does not exist !!! topNodeId >>> ".concat(topNodeId));
  return [nodeToTreeItem(topNode, topNodeId)];
};